import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Check } from "lucide-react";
import api from "@/lib/api";

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const ref = useRef(null);

  const loadCount = () => api.get("/notifications/unread-count").then((r) => setCount(r.data.count)).catch(() => {});
  const loadList = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 20000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);

  const toggle = () => { const n = !open; setOpen(n); if (n) loadList(); };
  const openItem = async (n) => {
    if (!n.read) { await api.post(`/notifications/${n.id}/read`); loadCount(); }
    setOpen(false);
    if (n.link) navigate(n.link);
  };
  const readAll = async () => { await api.post("/notifications/read-all"); loadCount(); loadList(); };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notifications-bell" className="relative text-slate-300 hover:text-white p-1.5">
        <Bell className="h-5 w-5" />
        {count > 0 && (
          <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center">
            {count > 9 ? "9+" : count}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto card-surface z-50 shadow-2xl" data-testid="notif-dropdown">
          <div className="flex items-center justify-between px-4 py-2.5 border-b border-border sticky top-0 bg-card">
            <span className="text-sm font-semibold text-white">Notifications</span>
            <button onClick={readAll} className="text-xs text-amber-400 hover:underline flex items-center gap-1"><Check className="h-3 w-3" /> Mark all read</button>
          </div>
          {items.length === 0 ? (
            <p className="text-sm text-muted-foreground p-6 text-center">No notifications</p>
          ) : items.map((n) => (
            <button key={n.id} onClick={() => openItem(n)} className={`w-full text-left px-4 py-3 border-b border-border/60 hover:bg-secondary/50 ${n.read ? "opacity-60" : ""}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="h-2 w-2 rounded-full bg-primary mt-1.5 shrink-0" />}
                <div className={n.read ? "pl-4" : ""}>
                  <p className="text-sm font-medium text-white">{n.title}</p>
                  <p className="text-xs text-muted-foreground line-clamp-2">{n.body}</p>
                  <p className="text-[10px] text-muted-foreground/70 font-mono mt-0.5">{new Date(n.created_at).toLocaleString()}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
